export enum ReportCustomFieldBuyer {
  PASS = '26A5B740-F609-4541-8D85-452697B21B9D',
  NO_PASS = 'E8FE0603-B6E8-468B-B6B9-A2D8535D82C7',
  PPP = '32B13770-7D03-4DA8-93D5-B288FBAA29B5',
  PENDING = '1D3754D6-23AD-4704-B00C-B56D1240746A',
  SAMPLE_PENDING = 'D6DD1922-42E5-44D1-82D6-D7DF84C8924A',
  LC_NO_PASS = '636A2780-A00F-4708-A74F-E3A7BD3E8A2F'
}
